<template>
  <div class="header-container">
    <div class="router-view">
      <el-breadcrumb
        separator-class="el-icon-arrow-right"
        separator=">">
        <el-breadcrumb-item
          v-for="(item, index) in $route.meta"
          :key="index">
          <span
            :class="{menuNow: index === $route.meta.length-1}"
            @click="changeRouter(item.url,index)">
            {{ item.name }}
          </span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="admin-right">
      <img
        class="admin-head"
        width="32px"
        src="../assets/images/dog.jpg">
      <el-dropdown
        @command="signOut"
        trigger="click">
        <span class="el-dropdown-link">
          {{ name }}
          <i class="el-icon-arrow-down el-icon--right"/>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>
            <img
              src="../assets/images/logout.png"
              class="dk-icon-back">
            退出
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import Utils from '../jslibs/utils';

export default {
  data() {
    return {
      name: '',
    };
  },

  created() {
    this.name = Utils.getCookie('adminName')
    console.log(this.name)
  },
  computed: {},
  methods: {
    changeRouter(url, index) {
      if (url) {
        const meta = this.$route.meta;
        this.$router.go(index + 1 - meta.length)
        // console.log(url);
        // this.$router.push({ path: url });
      }
    },
    signOut() {
      this.$router.push({ path: '/login' })
    },
  },
};
</script>

<style lang="less">
.header-container {
  padding:0 57px 0 30px;
  height: 73px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  margin: 0;
  width:calc(100vw - 300px);
  width:-webkit-calc(100vw - 300px);
  width:-moz-calc(100vw - 300px);
  position: fixed;
  border-bottom: 1px solid #e5e5e5;
  z-index: 2;
  .search-row {
    width: 100%;
  }
  .router-view {
    /deep/.el-breadcrumb{
      line-height: 20px;
    }
    .menuNow {
      font-size: 20px;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      color: rgba(76,76,76,1);
    }
  }
  .filter-view {
    display: flex;
    padding-right: 25px;
    align-items: center;
    .type {
      margin: 0 10px;
      color: #223040;
      background: rgba(0, 0, 0, 0);
      margin: 0 15px;
    }
  }
  .admin-right{
    height: 100%;
    display: flex;
    align-items: center;
    .admin-head{
      width: 32px;
      height: 32px;
      border-radius: 50%;
      margin-right: 12px;
    }
  }
}
.dk-icon-back {
  display: inline-block;
  width: 14px;
  height: 14px;
  margin: 12px 12px 0 0;
}

.top-search-input {
  width: 220px;
  margin: 0 10px;
  .search-icon {
    width: 36px !important;
    height: 36px !important;
    padding: 10px 11px !important;
  }
  .search-row {
    margin-bottom: 30px;
  }
}

</style>
